import "core-js/modules/es.array.push.js";
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/image/right.png';
import _imports_1 from '../../../assets/image/fff.png';
const _withScopeId = n => (_pushScopeId("data-v-f92be76a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-nav-tabs"
};
const _hoisted_2 = {
  class: "tk-tabs"
};
const _hoisted_3 = {
  key: 0,
  class: "tk-zhibo"
};
const _hoisted_4 = {
  key: 1,
  class: "tk-zhibo"
};
const _hoisted_5 = {
  key: 2,
  class: "tk-zhibo"
};
const _hoisted_6 = {
  key: 3,
  class: "tk-zhibo tk-zhibo_code"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mu"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://kj.49six.net:1888/?kl8",
  scrolling: "none",
  frameborder: "0"
}, null, -1));
const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = {
  class: "tk-lottery"
};
const _hoisted_11 = {
  class: "tk-main-box"
};
const _hoisted_12 = {
  class: "tk-box-playback"
};
const _hoisted_13 = {
  class: "tk-playback-title flex-between"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "开奖回放", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多开奖回放 ", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "imgs",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_17 = [_hoisted_15, _hoisted_16];
const _hoisted_18 = {
  class: "tk-playback-content"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "tk-play"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "tk-qishu"
};
const _hoisted_23 = {
  class: "tk-recommend-title"
};
const _hoisted_24 = {
  class: "title"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "推荐", -1));
const _hoisted_26 = {
  class: "tk-recommend-content"
};
const _hoisted_27 = {
  class: "flex-between"
};
const _hoisted_28 = {
  class: "tk-cont-l"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "九肖：", -1));
const _hoisted_30 = {
  class: "tk-cont-r"
};
const _hoisted_31 = {
  class: "flex-between"
};
const _hoisted_32 = {
  class: "tk-cont-l"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "六肖：", -1));
const _hoisted_34 = {
  class: "tk-cont-r"
};
const _hoisted_35 = {
  class: "flex-between"
};
const _hoisted_36 = {
  class: "tk-cont-l"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "四肖：", -1));
const _hoisted_38 = {
  class: "tk-cont-r"
};
const _hoisted_39 = {
  class: "flex-between"
};
const _hoisted_40 = {
  class: "tk-cont-l"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "一肖：", -1));
const _hoisted_42 = {
  class: "tk-cont-r"
};
const _hoisted_43 = {
  class: "flex-between"
};
const _hoisted_44 = {
  class: "tk-cont-l"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "十码：", -1));
const _hoisted_46 = {
  class: "tk-cont-r"
};
const _hoisted_47 = {
  class: "tk-return-back",
  ref: "majorbotton"
};
import videoComment from "@/components/mode/video.vue";
import videoComments from "@/components/mode/videos.vue";
import videoPlayer from "@/components/mode/videoPlayer.vue";
// import {isMobile} from 'react-device-detect';

import { useStore } from "vuex";
import { recommend, backVideo } from "@/utils/https/lottery";
import { open_date } from "@/utils/https/lottery";
import { nextTick } from "vue";

import { useRouter } from 'vue-router';
import { reactive, toRefs, computed, watch, onBeforeMount, onDeactivated, onActivated } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    var cler;
    const router = useRouter();
    let data = reactive({
      recommendArray: [],
      year: new Date().getFullYear(),
      videoList: [],
      http: JSON.parse(localStorage.getItem("config"))?.video_url,
      vodeoUrl: "https://streamw-azs-51.on.cc/src/smil:remote1_hd.smil/chunklist_b6628000.m3u8",
      lotteryType: "1",
      lotteryopne: false,
      activeIndex: 0,
      roomDom: 1,
      transitions: false,
      newTiems: []
    });
    let {
      recommendArray,
      videoList,
      http,
      vodeoUrl,
      lotteryType,
      lotteryopne,
      activeIndex,
      roomDom,
      transitions
    } = toRefs(data);
    let videoOption = reactive({
      autoplay: true,
      controls: true,
      sources: [{
        src: JSON.parse(localStorage.getItem("config"))?.xg_live,
        type: "application/x-mpegURL"
      }]
    });
    const $store = useStore(); //获取vuex

    const configInfo = computed(() => {
      return $store.state.config;
    });
    const nextLotterysb = computed(() => {
      return $store.state.nextLottery;
    });
    watch(() => configInfo.value, (val, old) => {
      data.http = configInfo.value.video_url;
      videoOption.sources[0].src = configInfo.value.xg_live;
    });
    onBeforeMount(async () => {
      clearInterval(cler);
      let confing = JSON.parse(localStorage.getItem("config"));
      // options.src =  confing.xg_live //香港直播源
      // options.src =  confing.am_live //澳门直播源
      recommendInfo(data.year, data.lotteryType);
      backVideos("", data.lotteryType);
      await nextTick();
      open_dates(data.lotteryType);
    });

    //页面请求区域

    let open_dates = lotteryType => {
      open_date({
        lotteryType
      }).then(res => {
        data.newTiems.length = 0;
        if (res.data.status == 20000) {
          data.newTiems.push(...res.data.data.dayList);
        }
      });
    };
    let recommendInfo = (year, type) => {
      //历史号码推荐
      recommend({
        year: year,
        lotteryType: type
      }).then(res => {
        if (res == undefined) return false;
        let datas = res.data.data;
        data.recommendArray.push(...datas);
      });
    };
    let backVideos = (year, type) => {
      backVideo({
        year: year,
        lotteryType: type,
        page: 1
      }).then(res => {
        if (res == undefined) return false;
        let datas = res.data.data.list;
        data.videoList.length = 0;
        datas.forEach((item, index) => {
          if (index < 4) {
            data.videoList.push(item);
          }
        });
      });
    };

    //功能区域
    let majorReturn = () => {
      localStorage.removeItem("lotteryNumber");
      data.roomDom += 1;
      data.transitions = true;
      clearInterval(cler);
      let next = nextLotterysb.value;
      var tiems = "2100-10-10 9点24分";
      next.forEach(item => {
        if (item.lotteryType == data.lotteryType) {
          tiems = item.lotteryTime + " " + item.time;
        }
      });
      cler = setInterval(() => {
        data.lotteryopne = openLotteryTiem(tiems);
      }, 2000);
      let c = setInterval(() => {
        clearTimeout(c);
        data.transitions = false;
      }, 1000);
    };
    let hadleGeto = item => {
      router.push({
        path: "/lottery/playback/details",
        query: {
          title: item.videoTitle,
          videoUrl: item.videoUrl,
          issue: item.issue,
          lotteryType: data.lotteryType
        }
      });
    };
    let principalTans = index => {
      data.activeIndex = index;
      data.lotteryType = index + 1;
      data.videoList.length = 0;
      backVideos("", data.lotteryType);
      open_dates(data.lotteryType);
      data.recommendArray.length = 0;
      recommendInfo(data.year, data.lotteryType);
      clearInterval(cler);
      ////////////////////////////////////////////////////////////////
      //开奖前十分钟显示直播页面
      let next = nextLotterysb.value; //
      var tiems = "2100-10-10 9点24分";
      next.forEach(item => {
        if (item.lotteryType == data.lotteryType) {
          tiems = item.lotteryTime + " " + item.time;
        }
      });
      cler = setInterval(() => {
        data.lotteryopne = openLotteryTiem(tiems);
      }, 2000);
    };
    let majorMore = () => {
      router.push({
        path: `lottery/playback`,
        query: {
          index: data.activeIndex,
          lottery: data.lotteryType
        }
      });
    };
    let getNowTime = () => {
      let dateTime;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      if (mm < 10) {
        mm = "0" + mm;
      }
      if (dd < 10) {
        dd = "0" + dd;
      }
      dateTime = yy + "-" + mm + "-" + dd;
      if (immobilizations(dateTime).length == 0) {
        return false;
      } else {
        return dateTime;
      }
    };
    const immobilizations = src => {
      var datas = [];
      data.newTiems.forEach((item, index) => {
        if (item == src) {
          datas.push(item);
        }
      });
      return datas;
    };
    let xgLottery = () => {
      var oDate = new Date(); //获取日期对象
      var oldTime = oDate.getTime(); //现在距离1970年的毫秒数
      if (getNowTime() != false) {
        let str = getNowTime().replace("-", "/");
        let strt = str.replace("-", "/");
        var newDate = new Date(`${strt + " 21:30"} GMT+08:00`);
        var newTime = newDate.getTime() + 60000 * 7;
        var second = Math.floor((newTime - oldTime) / 1000); //未来时间距离现在的秒数
        var day = Math.floor(second / (3600 * 24)); //整数部分代表小时；
        var hour = Math.floor(second / 3600) % 24; //整数部分代表小时；
        second %= 3600; //余数代表 剩下的秒数；
        var minute = Math.floor(second / 60);
        second %= 60;
        return [day, hour, minute];
      } else {
        return [-1, -1, -1];
      }
    };
    let openLotteryTiem = () => {
      let dgs = djs();
      let DateTime = timestampToDateTime(dgs);
      if (data.lotteryType == 2) {
        if (DateTime[0] == 21 && DateTime[1] < 36 && DateTime[1] >= 30) {
          return true;
        } else {
          return false;
        }
      }
      if (data.lotteryType == 6 || data.lotteryType == 7) {
        if (DateTime[0] == 21 && DateTime[1] < 36 && DateTime[1] >= 30) {
          return true;
        } else {
          return false;
        }
      }
      if (data.lotteryType == 1) {
        if (xgLottery()[2] <= 6 && xgLottery()[2] >= 0 && xgLottery()[0] == 0 && xgLottery()[1] == 0) {
          // 提前18分钟开始请求 相当于 21:22 开始请求
          return true;
        } else {
          return false;
        }
      }
    };
    let djs = () => {
      var now = new Date();
      // 获取本地时区
      var localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      // 设置中国时区
      var chinaTimeZone = "Asia/Shanghai";
      // 使用本地时区创建日期对象
      var localTime = new Date(now);
      // 将本地时间转换为中国时区
      var chinaTime = new Date(localTime.toLocaleString("en-US", {
        timeZone: chinaTimeZone
      }));
      var targetTime = new Date(chinaTime);
      // 设置目标时间为今天的21:30
      targetTime.setHours(21, 30, 0, 0);
      // 如果当前时间已经过了21:30，则目标时间改为明天的21:30
      if (chinaTime >= targetTime) {
        targetTime.setDate(chinaTime.getDate() + 1);
      }
      // 计算时间戳（单位：毫秒）
      var nowTimestamp = chinaTime.getTime();
      // console.log()
      return nowTimestamp;
    };
    function timestampToDateTime(timestamp) {
      // 创建一个 Date 对象
      var date = new Date(timestamp);

      // 获取年、月、日、时、分、秒
      var year = date.getFullYear();
      var month = date.getMonth() + 1; // 月份从0开始，需要加1
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();

      // 格式化输出
      return [(hours < 10 ? "0" : "") + hours, (minutes < 10 ? "0" : "") + minutes, (seconds < 10 ? "0" : "") + seconds];
    }
    onDeactivated(() => {
      clearInterval(cler);
    });
    onActivated(() => {
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState == "hidden") {
          //状态判断 离开浏览页面时
          let next = nextLotterysb.value;
          var tiems = "2100-10-10 9点24分";
          next.forEach(item => {
            if (item.lotteryType == data.lotteryType) {
              tiems = item.lotteryTime + " " + item.time;
            }
          });
          cler = setInterval(() => {
            data.lotteryopne = openLotteryTiem(tiems);
          }, 2000);
        }
      });
      let next = nextLotterysb.value;
      var tiems = "2100-10-10 9点24分";
      next.forEach(item => {
        if (item.lotteryType == data.lotteryType) {
          tiems = item.lotteryTime + " " + item.time;
        }
      });
      cler = setInterval(() => {
        data.lotteryopne = openLotteryTiem(tiems);
      }, 2000);
    });
    return (_ctx, _cache) => {
      const _component_lottery = _resolveComponent("lottery");
      const _component_headNav = _resolveComponent("headNav");
      const _component_majorBack = _resolveComponent("majorBack");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_headNav, {
        title: "开奖现场"
      }, {
        tkCont: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", null, [_createElementVNode("li", {
          class: _normalizeClass(_unref(activeIndex) == 0 ? 'active' : ''),
          onClick: _cache[0] || (_cache[0] = $event => _unref(principalTans)(0))
        }, " 香港六合彩 ", 2), _createElementVNode("li", {
          class: _normalizeClass(_unref(activeIndex) == 5 ? 'active' : ''),
          onClick: _cache[1] || (_cache[1] = $event => _unref(principalTans)(5))
        }, " 快乐八 ", 2), _createElementVNode("li", {
          class: _normalizeClass(_unref(activeIndex) == 1 ? 'active' : ''),
          onClick: _cache[2] || (_cache[2] = $event => _unref(principalTans)(1))
        }, " 新澳门六合彩 ", 2), _createElementVNode("li", {
          class: _normalizeClass(_unref(activeIndex) == 6 ? 'active' : ''),
          onClick: _cache[3] || (_cache[3] = $event => _unref(principalTans)(6))
        }, " 老澳 ", 2)])])]), _unref(activeIndex) == 0 && _unref(lotteryopne) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(videoPlayer, {
          options: _unref(videoOption)
        }, null, 8, ["options"])])) : _createCommentVNode("", true), _unref(activeIndex) == 1 && _unref(lotteryopne) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(videoComment)])) : _createCommentVNode("", true), _unref(activeIndex) == 6 && _unref(lotteryopne) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(videoComments)])) : _createCommentVNode("", true), _unref(activeIndex) == 5 && _unref(lotteryopne) ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [(_openBlock(), _createBlock(_component_lottery, {
          lottery: _unref(lotteryType),
          key: _unref(roomDom)
        }, null, 8, ["lottery"]))])]),
        _: 1
      }), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", {
        class: "more",
        onClick: _cache[4] || (_cache[4] = (...args) => _unref(majorMore) && _unref(majorMore)(...args))
      }, _hoisted_17)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(videoList), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          onClick: $event => _unref(hadleGeto)(item)
        }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
          src: _unref(http) + item.pictureUrl,
          alt: ""
        }, null, 8, _hoisted_21)]), _createElementVNode("div", _hoisted_22, _toDisplayString(item.videoTitle), 1)], 8, _hoisted_19);
      }), 128))])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recommendArray), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "tk-box-recommend",
          key: index
        }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("span", null, _toDisplayString(item.year), 1), _createElementVNode("b", null, "第" + _toDisplayString(item.issue) + "期", 1), _hoisted_25])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createTextVNode(_toDisplayString(item.nine_xiao), 1)]), _createElementVNode("div", _hoisted_30, _toDisplayString(item.nine_is_win == 1 ? "中奖" : ""), 1)]), _createElementVNode("li", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_hoisted_33, _createTextVNode(_toDisplayString(item.six_xiao), 1)]), _createElementVNode("div", _hoisted_34, _toDisplayString(item.six_is_win == 1 ? "中奖" : ""), 1)]), _createElementVNode("li", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_hoisted_37, _createTextVNode(_toDisplayString(item.four_xiao), 1)]), _createElementVNode("div", _hoisted_38, _toDisplayString(item.four_is_win == 1 ? "中奖" : ""), 1)]), _createElementVNode("li", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_hoisted_41, _createTextVNode(_toDisplayString(item.one_xiao), 1)]), _createElementVNode("div", _hoisted_42, _toDisplayString(item.one_is_win == 1 ? "中奖" : ""), 1)]), _createElementVNode("li", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_hoisted_45, _createTextVNode(_toDisplayString(item.ten_ma), 1)]), _createElementVNode("div", _hoisted_46, _toDisplayString(item.te_is_win == 1 ? "中奖" : ""), 1)])])])]);
      }), 128))]), _createVNode(_component_majorBack, {
        x: "11d",
        r: "10px",
        y: '62%'
      }), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", {
        class: "tk-back-button",
        onClick: _cache[5] || (_cache[5] = (...args) => _unref(majorReturn) && _unref(majorReturn)(...args))
      }, [_createElementVNode("img", {
        class: _normalizeClass(_unref(transitions) ? 'active' : ''),
        src: _imports_1,
        alt: ""
      }, null, 2)])], 512)], 64);
    };
  }
};